/**
 * FileManagementHeader
 *
 * Slim title block above the table/grid: shows "All Files & Folders" with
 * the total count badge. Search and view-mode toggle now live in the action
 * bar / breadcrumbs row (see FileManagement.tsx).
 */

import type { FileManagementHeaderProps } from "../types/fileManagement.types";

const FileManagementHeader = ({ totalCount }: FileManagementHeaderProps) => {
  return (
    <div className="flex items-center gap-1.5">
      <h3 className="text-lg font-medium text-heading-text dark:text-heading-text-dk">
        All Files & Folders
      </h3>
      <span className="border border-gray-100 dark:border-gray-100-dk rounded px-1 py-0.5 text-xxs font-semibold text-verba-indigo dark:text-verba-indigo-dk leading-normal">
        {totalCount}
      </span>
    </div>
  );
};

export default FileManagementHeader;
